<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: "App"
}
</script>

<style>
@import "../static/css/common.css";
@import "../static/css/index.css";
</style>



// WEBPACK FOOTER //
// src/App.vue